import { createSlice } from "@reduxjs/toolkit"

export const SETTINGS_WRITE_SCOPE_HEADER = "X-Settings-Write-Scope"
export const GRID_WRITE_SCOPE = "grid"

interface WriteScopeState {
  /** Mounted editors that are deliberately editing a Settings Grid value. */
  gridEditors: number
}

const initialState: WriteScopeState = { gridEditors: 0 }

/**
 * While a grid-scoped editor is on screen every chat write carries the grid
 * opt-in header. The backend only honours it for sections the grid manages
 * and the viewer may edit, so an unrelated write in the same session is a
 * plain chat write as before.
 */
const writeScopeSlice = createSlice({
  name: "settingsWriteScope",
  initialState,
  reducers: {
    gridWriteScopeEntered: state => {
      state.gridEditors += 1
    },
    gridWriteScopeLeft: state => {
      state.gridEditors = Math.max(0, state.gridEditors - 1)
    }
  }
})

export const { gridWriteScopeEntered, gridWriteScopeLeft } = writeScopeSlice.actions
export const writeScopeReducer = writeScopeSlice.reducer

interface StateWithWriteScope {
  settingsWriteScope?: WriteScopeState
}

export const isGridWriteScopeActive = (state: unknown): boolean => {
  const slice = (state as StateWithWriteScope | null | undefined)?.settingsWriteScope
  return (slice?.gridEditors ?? 0) > 0
}
